module.exports = __webpack_public_path__ + "img/printsign_mingliang.c2657510.png";